import React, { useEffect, useState } from "react";
import { json, Link, useNavigate } from "react-router-dom";
import NavBar from "./NavBar";
import Footer from "./Footer";
import axios from "axios";
import InputPagamento from "../components/Inputs/InputPagamento";
import PaymentMonthsSelector, {
  MONTH_OPTIONS,
  QUARTER_OPTIONS,
} from "../components/PaymentMonthsSelector";
import { API_BASE_URL } from "../services/api";
import { CheckCheck, ChevronLeft, LoaderCircle, OctagonAlert } from "lucide-react";
import { jwtDecode } from "jwt-decode";

function ehPlanoTrimestral(validadeusuario) {
  const texto = String(validadeusuario || "").toLowerCase().trim();
  return texto === "3 meses" || texto.includes("trimestral");
}

export default function PagamentoViaMpesa() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [mensagemInput, setMensagemInput] = useState("");
  const [profile, setProfile] = useState("");
  const [preco, setPreco] = useState(null);
  const [numero, setNumero] = useState("");
  const [valor, setValor] = useState("");
  const [pago, setPago] = useState(false);
  const [reciboId, setReciboId] = useState(null);
  const [plano, setPlano] = useState("");
  const [trimestre, setTrimestre] = useState(false);
  const [meses, setMeses] = useState(1);
  const opcoesMeses = trimestre ? QUARTER_OPTIONS : MONTH_OPTIONS;
  const diasPorMes = trimestre ? 30 : 31;
  const totalPagamento = trimestre
    ? Number(preco || 0) * (meses / 3)
    : Number(preco || 0) * meses;
  const totalVisivel = totalPagamento || Number(valor || 0);

  async function mostrarPlano() {
    try {
      const token = localStorage.getItem("token");
  
      if (!token) {
        console.warn("Token não encontrado!");
        return;
      }
  
      const parsedToken = token;
      const dadosDoLocalStorage = jwtDecode(parsedToken);
  
      if (!dadosDoLocalStorage?.idUsuario) {
        console.warn("Token inválido!");
        return;
      }
  
      const response = await axios.get(
        `${API_BASE_URL}/usuario/${dadosDoLocalStorage.idUsuario}`,
        {
          headers: { Authorization: `Bearer ${parsedToken}` } // Enviando token no header
        }
      );
        if(response.data){
          const planoTrimestral = ehPlanoTrimestral(response.data.validadeusuario);
          setTrimestre(planoTrimestral);
          setMeses(planoTrimestral ? 3 : 1);
          if(response.data.profileusuario === "PLANO-6Mbps" && response.data.precousuario === 2320){
            setPlano("PLANO FERRO 3Mbps")
            setValor(2320)
            setPreco(2320)
            setProfile(response.data.profileusuario)
          }else if(response.data.profileusuario === "PLANO-8Mbps" && response.data.precousuario === 3480){
            setPlano("PLANO PRATA 5Mbps")
            setValor(3480)
            setPreco(3480)
            setProfile(response.data.profileusuario)
          }else if(response.data.profileusuario === "PLANO-10Mbps" && response.data.precousuario === 5800){
            setPlano("PLANO COBRE 8Mbps")
            setValor(5800)
            setPreco(5800)
            setProfile(response.data.profileusuario)
          }else if(response.data.profileusuario === "PLANO-12Mbps" && response.data.precousuario === 8120){
            setPlano("PLANO ALUMINIO 10Mbps")
            setValor(8120)
            setPreco(8120)
            setProfile(response.data.profileusuario)
          }else if(response.data.profileusuario === "PLANO-14Mbps" && response.data.precousuario === 9628){
            setPlano("PLANO OURO 12Mbps")
            setValor(9628)
            setPreco(9628)
            setProfile(response.data.profileusuario)
          }else if(response.data.profileusuario === "PLANO-16Mbps" && response.data.precousuario === 11948){
            setPlano("PLANO CHUMBO 14Mbps")
            setValor(11948)
            setPreco(11948)
            setProfile(response.data.profileusuario)
          }else if(response.data.profileusuario === "PLANO-18Mbps" && response.data.precousuario === 13688){
            setPlano("PLANO MERCURIO 16Mbps")
            setValor(13688)
            setPreco(13688)
            setProfile(response.data.profileusuario)
          }else if(response.data.profileusuario === "PLANO-20Mbps" && response.data.precousuario === 14500){
            setPlano("PLANO PLATINA 18Mbps")
            setValor(14500)
            setPreco(14500)
            setProfile(response.data.profileusuario)
          }else if(response.data.profileusuario === "PLANO-20Mbps" && response.data.precousuario === 16008){
            setPlano("PLANO RODIO 20Mbps")
            setValor(16008)
            setPreco(16008)
            setProfile(response.data.profileusuario)
          }else if(response.data.profileusuario === "PLANO-4Mbps" && response.data.precousuario === 18000){
            setPlano("PLANO 4Mbps")
            setValor(18000)
            setPreco(18000)   
            setProfile(response.data.profileusuario)
          }else if(response.data.profileusuario === "PLANO-8Mbps" && response.data.precousuario === 27000){
            setPlano("PLANO 6Mbps")
            setValor(27000)
            setPreco(27000)
            setProfile(response.data.profileusuario)
          }else if(response.data.profileusuario === "PLANO-10Mbps" && response.data.precousuario === 36000){
            setPlano("PLANO 8Mbps")
            setValor(36000)
            setPreco(36000)
            setProfile(response.data.profileusuario)
          }else if(response.data.profileusuario === "PLANO-12Mbps" && response.data.precousuario === 45000){
            setPlano("PLANO 10Mbps")
            setValor(45000)
            setPreco(45000)
            setProfile(response.data.profileusuario)
          }else if(response.data.profileusuario === "PLANO-14Mbps" && response.data.precousuario === 67200){
            setPlano("PLANO 15Mbps")
            setValor(67200)
            setPreco(67200)
            setProfile(response.data.profileusuario)
          }else if(response.data.profileusuario === "PLANO-20Mbps" && response.data.precousuario === 9200){
            setPlano("PLANO 20Mbps")
            setValor(9200)
            setPreco(9200)
            setProfile(response.data.profileusuario)
          }
        }else{
            console.log("houve erro")
        }

    } catch (erro) {
      console.error("Erro ao buscar os dados do usuário:", erro);
    }
  }

  const gerarLetrasAleatorias = (tamanho) => {
    const letras = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    let resultado = "";
    for (let i = 0; i < tamanho; i++) {
      resultado += letras.charAt(Math.floor(Math.random() * letras.length));
    }
    return resultado;
  };

  const gerarDataAtual = () => {
    const dataAtual = new Date();
    // Obtém as partes da data
    const ano = dataAtual.getFullYear();
    const mes = String(dataAtual.getMonth() + 1).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
    const dia = String(dataAtual.getDate()).padStart(2, "0");

    // Obtém as partes do horário
    const horas = String(dataAtual.getHours()).padStart(2, "0");
    const minutos = String(dataAtual.getMinutes()).padStart(2, "0");
    const segundos = String(dataAtual.getSeconds()).padStart(2, "0");

    // Constrói a data no formato desejado
    const dataFormatada = `${ano}-${mes}-${dia} ${horas}:${minutos}:${segundos}`;
    return dataFormatada;
  };

  async function recarregarPacote() {
    setMensagemInput("");
    setLoading(true);
    try {
    const token = localStorage.getItem("token");
      if (!/^(84|85)\d{7}$/.test(numero)) {
        console.log(
          "Número de telefone inválido. Deve começar com 84 ou 85 e conter 9 dígitos."
        );
        setLoading(false);
        setMensagemInput(
          "Por favor, insira um número de telefone válido no maximo 9 numeros começando com 84 ou 85."
        );
        return;
      }
      let valoresAleatorios = gerarLetrasAleatorias(12);
      if(token){
        const dadosDoLocalStorage = jwtDecode(token)
        if(dadosDoLocalStorage){
          if (!profile || !Number.isFinite(Number(preco))) {
            setMensagemInput("Aguarde os dados do plano carregarem.");
            return;
          }

          const valorTotal = trimestre
            ? Number(preco) * (meses / 3)
            : Number(preco) * meses;

          if (!Number.isFinite(valorTotal) || valorTotal <= 0) {
            setMensagemInput("Valor do pagamento invalido.");
            return;
          }

          const dadosPagamento = await axios.put(
            `${API_BASE_URL}/${trimestre?"pagamentotrimestre":"pagamento"}/${dadosDoLocalStorage.idUsuario}`,
            {
              transaction_ref: "EyazsImperium",
              msisdn: `258${numero}`,
              amount: valorTotal,
              precoPlano: parseFloat(preco),
              meses,
              thirdparty_ref: valoresAleatorios,
              profile,
              descricao: profile || plano,
              gerarRecibo: true,
            },
            {
              headers:{
                'Authorization': `Bearer ${token}`,  // Substitua pelo seu token de autenticação, se necessário
                'Content-Type': 'application/json'  // Define o tipo de conteúdo como JSON
              }
            }
          );
          if (dadosPagamento) {
            if (dadosPagamento.data?.reciboId) {
              setReciboId(dadosPagamento.data.reciboId);
              setNumero("");
              setPago(true);
              return;
            }
            if (dadosPagamento.data?.reciboPendente) {
              setReciboId(null);
              setMensagemInput("Pagamento confirmado. Recibo pendente para o super admin gerar.");
              setNumero("");
              setPago(true);
              return;
            }
            const profileBackUp = await axios.get(
              `${API_BASE_URL}/usuario/${dadosDoLocalStorage.idUsuario}`,
              {
                headers: {
                  'Authorization': `Bearer ${token}`,  // Substitua pelo seu token de autenticação, se necessário
                  'Content-Type': 'application/json'  // Define o tipo de conteúdo como JSON
                }
              }
            );
            if (profileBackUp) {
              try {
                console.log("plano atualizado!");
                const atualizarPlano = await axios.put(
                  `${API_BASE_URL}/usuario/${dadosDoLocalStorage.idUsuario}`,
                  {
                    profile: profileBackUp.data.profileusuario,
                  },
                  {
                    headers: {
                      'Authorization': `Bearer ${token}`,  // Substitua pelo seu token de autenticação, se necessário
                      'Content-Type': 'application/json'  // Define o tipo de conteúdo como JSON
                    }
                  }
                );
                if (atualizarPlano) {
                  const atualPrecoUsuario = await axios.put(
                    `${API_BASE_URL}/usuario/${dadosDoLocalStorage.idUsuario}`,
                    {
                      precousuario: parseFloat(preco),
                      profileusuario: profile
                    },
                    {
                      headers: {
                        'Authorization': `Bearer ${token}`,  // Substitua pelo seu token de autenticação, se necessário
                        'Content-Type': 'application/json'  // Define o tipo de conteúdo como JSON
                      }
                    }
                  );
                  if (atualPrecoUsuario) {
                    if (atualPrecoUsuario) {
                      console.log(
                        "Preco e Plano do usuario Atualizados com Sucesso!"
                      );
                      try {
                        const dataAtual = gerarDataAtual();
                        const gerarRecibo = await axios.post(
                          //845610112
                          `${API_BASE_URL}/recibo`,
                          {
                            idUsuario: dadosDoLocalStorage.idUsuario,
                            userName: dadosDoLocalStorage.name,
                            meioPagamento: "Mpesa",
                            numeroTelefone: numero,
                            valor: valorTotal,
                            plano: profile,
                            descricao: profile,
                            dataTransacao: dataAtual,
                          },
                          {
                            headers: {
                              'Authorization': `Bearer ${token}`,  // Substitua pelo seu token de autenticação, se necessário
                              'Content-Type': 'application/json'  // Define o tipo de conteúdo como JSON
                            }
                          }
                        );
                        if (gerarRecibo) {
                          setReciboId(gerarRecibo.data?.reciboId || null);
                          console.log("Recibo gerado com Sucesso!");
                          setNumero("");
                          setPago(true);
                        }
                      } catch (erro) {
                        console.log(erro);
                      }
                    }
                    console.log("Plano atualizado com Sucesso!");
                  }
                }
              } catch (erro) {
                console.log(erro);
              }
            }
            console.log(dadosPagamento.data);
          }
        }
      }
    } catch (erro) {
      console.log(erro);
    } finally {
      setLoading(false);
    }
  }

  const propsInputPagamentoMpesa = {
    type: "text",
    placeholder: "digite o numero do Mpesa",
    mudar: (e) => setNumero(e.target.value),
    value: numero,
  };

  useEffect(() => {
    mostrarPlano();
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      {/* NavBar */}
      <div className="bg-blue-500 sticky top-0">
        <NavBar />
      </div>

      {/* Conteúdo Principal */}
      {pago ? (
        <div>
          <div className="flex justify-center items-center h-full">
            <div className="bg-green-700 m-8 text-white p-6 md:p-10 rounded-3xl shadow-2xl max-w-md w-full text-center">
              <div className="flex justify-center mb-4">
                <CheckCheck size={50} strokeWidth={2} />
              </div>
              <h1 className="text-2xl md:text-3xl font-bold mb-2">
                Pagamento Confirmado!
              </h1>
              <p className="text-lg md:text-xl mb-4">
                Obrigado pelo seu pagamento. Seu plano foi atualizado com
                sucesso.
              </p>
              <Link
                to="/home"
                className="inline-block mt-4 px-6 py-2 rounded-lg bg-green-500 text-gray-100 hover:bg-green-600 transition duration-300 font-semibold"
              >
                Voltar à Página Inicial
              </Link>
              {reciboId && (
                <Link
                  to={`/recibo/${reciboId}`}
                  className="ml-0 inline-block mt-3 px-6 py-2 rounded-lg bg-white text-green-700 hover:bg-green-50 transition duration-300 font-semibold sm:ml-3"
                >
                  Ver recibo
                </Link>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="flex-grow flex flex-col justify-between font-questrial">
          <button
            className="group ml-6 my-2"
            onClick={() => {
              navigate(-1);
            }}
          >
            <div className="flex md:flex lg:hidden">
              <div>
                <ChevronLeft className="group-hover:font-semibold" />
              </div>
              <div>
                <span className="text-sm group-hover:font-semibold">
                  Voltar
                </span>
              </div>
            </div>
          </button>
          {/* Título do Perfil */}
          <div className="h-[60px] border flex items-center justify-center bg-gray-100">
            <h2 className="font-semibold">{plano}</h2>
          </div>

          {/* Seção de Pagamento */}
          <div className="border lg:mx-auto w-[80%] mx-auto sm:mx-auto sm:w-[40%] md:w-[40%] lg:w-[40%] bg-gray-50 my-6 p-6 rounded-lg shadow-md">
            {/* Logotipo */}
            <div className="flex justify-center mb-6">
              <img
                className="w-[170px]"
                src="../../images/vodacom.png"
                alt="Vodacom"
              />
            </div>

            {/* Total */}
            <div className="flex justify-between mb-4 text-lg">
              <span>Total</span>
              <span className="font-semibold">
                {totalVisivel.toLocaleString("pt-MZ")} MZN
              </span>
            </div>
            <PaymentMonthsSelector
              meses={meses}
              onChange={setMeses}
              total={totalVisivel}
              options={opcoesMeses}
              diasPorMes={diasPorMes}
            />

            {/* Input de Pagamento */}
            <div className="w-full mb-4">
              <InputPagamento {...propsInputPagamentoMpesa} />
            </div>

            {/* Botão de Pagamento */}
            {loading ? (
              <button className="w-full mt-4 bg-blue-500 p-2 text-white rounded-lg">
                <div className="flex justify-center items-center gap-1">
                  <span>Processando</span>
                  <LoaderCircle
                    strokeWidth={4}
                    size={18}
                    className={loading ? "animate-spin text-white" : ""}
                  />
                </div>
              </button>
            ) : (
              <button
                onClick={() => {
                  recarregarPacote();
                  // Certifique-se de que esta função esteja corretamente definida
                }}
                className="w-full mt-4 bg-blue-500 p-2 text-white rounded-lg hover:bg-blue-400"
              >
                Pagar
              </button>
            )}
            {mensagemInput && (
              <div className="flex items-center text-sm mt-2 p-4 bg-red-500 text-white rounded-lg">
                <OctagonAlert />
                <span>{mensagemInput}</span>
              </div>
            )}

            {/* Aviso sobre termos e condições */}
            <div className="mt-4 text-center text-sm text-gray-400">
              Ao clicar "Pagar", eu confirmo que li e estou de acordo{" "}
              <Link className="text-blue-500 hover:underline" to="/termosdeuso">
                com os termos e condições de uso
              </Link>
            </div>
          </div>
        </div>
      )}
      {/* Footer */}
      <div className="bg-blue-500 text-gray-200 p-2">
        <Footer />
      </div>
    </div>
  );
}
